(function () {
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Header offset vars + hide-on-scroll/reveal-on-scroll-up (pr-nav-up,
  // pr-header-solid, --pr-announce-height, --header-height) now live in
  // pure-rose-shop-nav.js, which loads on every template - not just index -
  // so the mobile header behaves the same way on the homepage and elsewhere.

  // The rotating word under "Choose to Feel" (pr-hero-banner.liquid). It has
  // a line of its own, so the line above never moves when it changes and no
  // width fitting is needed (see .pr-hero__rotator in pure-rose-homepage.css).
  document.querySelectorAll("[data-pr-rotator]").forEach(function (el) {
    var phrases = el.querySelectorAll(".pr-hero__rotator-phrase");
    if (!phrases.length) return;
    // Let the first word wave in (see `.pr-hero__rotator:not(.is-ready)` in
    // pure-rose-homepage.css). Two frames, so its hidden start state has
    // been painted and there is something to transition from.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add("is-ready");
      });
    });
    if (phrases.length < 2 || reduceMotion) return;
    var i = 0;

    // Toggling a class rather than rewriting textContent: the phrases are all
    // in the markup, stacked, so the CSS can wash each one in as a wave.
    // 2.5s a word, by request (Sep 30; it has been 5s, 4s, 3s
    // and 2s -- 3s read as too long). The next word starts 0.5s after the
    // swap and is fully in at ~1.7s, so it rests ~0.8s before it leaves.
    // Keep HOLD_MS above ~1.8s or words will leave mid-arrival.
    //
    // Every phrase holds the same time. The first one used to hold 5s (Good,
    // then Joy, by request Oct 7); the client then asked for no pause after
    // Joy, so the words change at an even pace (Oct 20). A chained timeout
    // rather than setInterval is kept so a per-word hold can come back.
    //
    // The outgoing phrase gets `is-leaving` so it drifts up and dissolves
    // (see pure-rose-homepage.css); it is cleared once it is gone, which
    // drops it back below the line, masked out, ready to wash in next time.
    // LEAVE_MS matches the 0.8s exit there.
    var HOLD_MS = 2500;
    var LEAVE_MS = 800;
    function holdFor() {
      return HOLD_MS;
    }
    function next() {
      var leaving = phrases[i];
      leaving.classList.remove("is-active");
      leaving.classList.add("is-leaving");
      setTimeout(function () {
        leaving.classList.remove("is-leaving");
      }, LEAVE_MS);
      i = (i + 1) % phrases.length;
      phrases[i].classList.add("is-active");
      setTimeout(next, holdFor(i));
    }
    setTimeout(next, holdFor(i));
  });

  // Every Shop now button (the one on the hero's edge and the sticky one)
  // opens the Shop now sheet instead of leaving for the collection page;
  // where <dialog> is unsupported it falls back to scrolling to the first
  // product row.
  // Shop now usage, for deciding whether the sheet should go full screen:
  // opens by trigger, and closes by how and after how long (Tor, review call
  // Sep 29). Product picks are already counted on the PDP via
  // pr_src=shop_all_sheet; `product` closes here are best effort, since the
  // page is unloading. The drawer's own Shop menu never fires these.
  // Props are nested under `properties` -- the only shape the Social Ocean
  // pixel forwards reliably (see cart.add_to_cart in product-form.js).
  function publishShopNow(name, properties) {
    var shopify = window.Shopify;
    if (!(shopify && shopify.analytics && shopify.analytics.publish)) return;
    var visitor = document.cookie.match(/(?:^|; )_shopify_y=([^;]*)/);
    shopify.analytics.publish("shop_now." + name, {
      visitorId: visitor ? decodeURIComponent(visitor[1]) : null,
      properties: properties
    });
  }

  var shopSheet = document.querySelector("[data-pr-shop-sheet]");
  var openShopSheet =
    shopSheet && typeof shopSheet.showModal === "function" ? wireShopSheet(shopSheet) : null;
  var firstProducts = document.querySelector(".pr-feature");
  document.querySelectorAll("[data-pr-shop-open]").forEach(function (link) {
    if (!openShopSheet && !firstProducts) return;
    link.addEventListener("click", function (e) {
      e.preventDefault();
      if (openShopSheet) openShopSheet(link.getAttribute("data-pr-shop-open") || "unknown");
      else firstProducts.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    });
  });

  // /?shop-now=1 (the empty Rebuy cart's Shop Now) opens the sheet on
  // phones, as the hero's button does; desktop opens the header panel in
  // pure-rose-shop-nav.js, which also takes the param off the URL.
  if (
    openShopSheet &&
    window.matchMedia("(max-width: 767px)").matches &&
    /(?:^|[?&])shop-now=1(?:&|$)/.test(location.search)
  ) {
    openShopSheet("cart_empty");
  }

  // Sticky Shop Now button (pr-hero-banner.liquid). It rises while the
  // visitor scrolls down and sinks while they scroll up -- browsing forward
  // gets the shortcut, looking back gets the screen -- and stays down at the
  // very top, while the hero's own Shop Now is anywhere on screen (one
  // button at a time), and while the footer is on screen, so it
  // never covers the footer's links. Showing it from the first scroll, next
  // to the hero button, was tried on Sep 29 and reverted on Sep 30. A few
  // pixels of slack stops a trembling thumb from flickering it.
  document.querySelectorAll("[data-pr-shop-all]").forEach(function (bar) {
    var SLACK_PX = 8;
    var TOP_PX = 80;
    var footerInView = false;
    var heroShopInView = false;
    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.scrollY;
      var delta = y - lastY;
      if (Math.abs(delta) < SLACK_PX) return;
      var show = delta > 0 && y > TOP_PX && !footerInView && !heroShopInView;
      bar.classList.toggle("is-hidden", !show);
      lastY = y;
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    var footer = document.querySelector("footer.pr-footer");
    if (footer && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        footerInView = entries[0].isIntersecting;
        if (footerInView) bar.classList.add("is-hidden");
      }).observe(footer);
    }

    // The hero's button hands over to the sticky one only once it has left
    // the screen entirely, so the two are never seen together. (Handing over
    // when it reached the top third was tried, and showed both at once --
    // client, Oct 1.)
    var heroShop = document.querySelector("[data-pr-hero-shop]");
    if (heroShop && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        heroShopInView = entries[0].isIntersecting;
        if (heroShopInView) bar.classList.add("is-hidden");
      }).observe(heroShop);
    }
  });

  // The Shop now sheet (pr-hero-banner.liquid, styled in
  // pure-rose-homepage.css). Returns its open function. `is-open` drives the
  // slide, so it goes on a frame after showModal (the panel needs a painted
  // start state to slide from) and comes off before close(), which waits for
  // the slide to finish -- otherwise the sheet would vanish mid-air. Closes
  // on the X, on a tap on the dimmed page, on Escape, and on a swipe down on
  // the head past DRAG_CLOSE_PX; a shorter drag springs back.
  //
  // The page behind is held still by refusing touchmove on the backdrop, not
  // by `overflow: hidden` on <html>: toggling that on iOS Safari left the
  // fixed Shop all button unresponsive after the sheet closed, until the page
  // was scrolled again. The panel's own scroll is kept in by
  // overscroll-behavior.
  function wireShopSheet(sheet) {
    var panel = sheet.querySelector("[data-pr-shop-sheet-panel]");
    var grab = sheet.querySelector("[data-pr-shop-sheet-grab]");
    var closeBtn = sheet.querySelector("[data-pr-shop-sheet-close]");
    var SLIDE_MS = 450;
    var DRAG_CLOSE_PX = 80;
    var closing = null;
    // The current open, for the close event; cleared once reported so a
    // close is never counted twice.
    var session = null;

    function reportClose(method) {
      if (!session) return;
      publishShopNow("closed", {
        trigger: session.trigger,
        surface: "sheet",
        method: method,
        open_ms: Date.now() - session.at
      });
      session = null;
    }

    function open(trigger) {
      clearTimeout(closing);
      // Tapped again while still sliding away: just bring it back up.
      if (sheet.open) {
        sheet.classList.add("is-open");
        return;
      }
      session = { trigger: trigger, at: Date.now() };
      publishShopNow("opened", { trigger: trigger, surface: "sheet" });
      panel.scrollTop = 0;
      sheet.showModal();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          sheet.classList.add("is-open");
        });
      });
    }

    function close(method) {
      if (!sheet.open || !sheet.classList.contains("is-open")) return;
      reportClose(method);
      sheet.classList.remove("is-open");
      closing = setTimeout(function () {
        sheet.close();
      }, reduceMotion ? 0 : SLIDE_MS);
    }

    if (closeBtn)
      closeBtn.addEventListener("click", function () {
        close("close_button");
      });
    panel.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest("a[href]")) reportClose("product");
    });
    // A click on the ::backdrop is dispatched to the <dialog> itself; clicks
    // inside the panel land on its children.
    sheet.addEventListener("click", function (e) {
      if (e.target === sheet) close("backdrop");
    });
    sheet.addEventListener(
      "touchmove",
      function (e) {
        // The backdrop, or a panel short enough not to scroll -- where
        // overscroll-behavior has nothing to contain and the page would move.
        if (e.target === sheet || panel.scrollHeight <= panel.clientHeight) e.preventDefault();
      },
      { passive: false }
    );
    sheet.addEventListener("cancel", function (e) {
      e.preventDefault();
      close("escape");
    });

    if (grab) {
      var startY = null;
      var dragY = 0;
      grab.addEventListener(
        "touchstart",
        function (e) {
          startY = e.touches[0].clientY;
          dragY = 0;
          panel.style.transition = "none";
        },
        { passive: true }
      );
      grab.addEventListener(
        "touchmove",
        function (e) {
          if (startY === null) return;
          dragY = Math.max(0, e.touches[0].clientY - startY);
          panel.style.transform = "translateY(" + dragY + "px)";
        },
        { passive: true }
      );
      var endDrag = function () {
        if (startY === null) return;
        startY = null;
        // Hand back to the stylesheet: from where the finger left it, the
        // panel slides either home or away on the usual curve.
        panel.style.transition = "";
        panel.style.transform = "";
        if (dragY > DRAG_CLOSE_PX) close("swipe");
      };
      grab.addEventListener("touchend", endDrag);
      grab.addEventListener("touchcancel", endDrag);
    }

    return open;
  }

  document.querySelectorAll("[data-pr-science]").forEach(function (track) {
    var root = track.closest(".pr-science");
    var posts = track.querySelectorAll(".pr-science__post");
    var dotsWrap = root ? root.querySelector("[data-pr-science-dots]") : null;
    if (!posts.length || !dotsWrap) return;
    var dots = dotsWrap.querySelectorAll(".pr-science__dot");
    var index = 0;

    function goTo(next) {
      index = (next + posts.length) % posts.length;
      posts.forEach(function (post, i) {
        post.classList.toggle("is-active", i === index);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle("is-active", i === index);
      });
    }

    var autoplayTimer;

    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    function startAutoplay() {
      stopAutoplay();
      if (reduceMotion || posts.length < 2) return;
      autoplayTimer = setInterval(function () {
        goTo(index + 1);
      }, 5000);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        goTo(i);
        startAutoplay();
      });
    });

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);
    root.addEventListener("focusout", startAutoplay);

    startAutoplay();
  });

  document.querySelectorAll("[data-pr-recipes]").forEach(function (root) {
    var track = root.querySelector("[data-pr-recipes-track]");
    var dots = root.querySelectorAll("[data-pr-recipes-dot]");
    var cards = root.querySelectorAll(".pr-recipes__card");
    if (!track || !cards.length) return;

    var index = 0;

    function perView() {
      return window.matchMedia("(max-width: 767px)").matches ? 2 : 3;
    }

    // Live theme's Slick carousel runs `infinite: true`, which is why it has
    // one dot per recipe (not one per "page") and every dot is reachable:
    // Slick pads the trailing view with clones of the first slides so the
    // last few dots don't run out of cards to show. Mirror that here by
    // cloning enough leading cards onto the end of the track so any index up
    // to the last real card always has a full, non-empty row to slide to.
    var maxPerView = 3;
    var cloneCount = Math.min(maxPerView - 1, cards.length - 1);
    for (var c = 0; c < cloneCount; c++) {
      var clone = cards[c].cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.querySelectorAll("a").forEach(function (a) {
        a.setAttribute("tabindex", "-1");
      });
      track.appendChild(clone);
    }

    function maxIndex() {
      return cards.length - 1;
    }

    function goTo(next) {
      var visible = perView();
      var max = maxIndex();
      index = Math.max(0, Math.min(next, max));
      track.style.transform = "translateX(-" + index * (100 / visible) + "%)";
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    }

    var autoplayTimer;

    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    function startAutoplay() {
      stopAutoplay();
      if (reduceMotion || cards.length < 2) return;
      autoplayTimer = setInterval(function () {
        goTo(index >= maxIndex() ? 0 : index + 1);
      }, 3000);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        goTo(i);
        startAutoplay();
      });
    });

    window.addEventListener("resize", function () {
      goTo(index);
    });

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);
    root.addEventListener("focusout", startAutoplay);

    goTo(0);
    startAutoplay();
  });

  document.querySelectorAll("[data-pr-vcar]").forEach(function (root) {
    var track = root.querySelector("[data-pr-vcar-track]");
    var dots = root.querySelectorAll("[data-pr-vcar-dot]");
    var cards = root.querySelectorAll("[data-pr-vcar-card]");
    if (!track || !dots.length || cards.length < 2) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    }

    var cardObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            setActive(Array.prototype.indexOf.call(cards, entry.target));
          }
        });
      },
      { root: track, threshold: [0.6] }
    );
    cards.forEach(function (card) {
      cardObserver.observe(card);
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        cards[i].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      });
    });
  });

  document.querySelectorAll(".pr-vcar__card").forEach(function (card) {
    var video = card.querySelector("video");
    var play = card.querySelector(".pr-vcar__play");
    if (!video || !play) return;
    video.setAttribute("preload", "none");
    video.controls = false;
    play.addEventListener("click", function () {
      document.querySelectorAll(".pr-vcar__card video").forEach(function (other) {
        if (other !== video) {
          other.pause();
          var otherCard = other.closest(".pr-vcar__card");
          if (otherCard) otherCard.classList.remove("is-playing");
        }
      });
      video.controls = true;
      video.play().catch(function () {});
      card.classList.add("is-playing");
    });
    video.addEventListener("ended", function () {
      card.classList.remove("is-playing");
      video.controls = false;
    });
  });

  var videos = document.querySelectorAll("[data-pr-video]");
  if (!videos.length) return;

  function playVideo(video) {
    if (video.readyState < 2) {
      video.load();
    }
    video.play().catch(function () {});
  }

  if (reduceMotion) return;

  if (!("IntersectionObserver" in window)) {
    videos.forEach(function (video) {
      playVideo(video);
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          playVideo(video);
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.15 }
  );

  videos.forEach(function (video) {
    observer.observe(video);
  });
})();
